import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import 'bootstrap/dist/js/bootstrap.min'
import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/fonts/icons.js'
import './Services/GlobalVariables'
import Loading from 'vue-loading-overlay';
import DrawerLayout from 'vue-drawer-layout'

import vSelect from 'vue-select'
import "vue-select/dist/vue-select.css";
import 'vue-loading-overlay/dist/vue-loading.css';

import 'vue-good-table/dist/vue-good-table.css'

import VueGoodTablePlugin from 'vue-good-table';

Vue.use(VueGoodTablePlugin);
Vue.component('v-select', vSelect)
Vue.component('loading', Loading);
Vue.use(DrawerLayout);
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
